/**
 * Mobile UX Enhancement JavaScript v2.0 (Cleaned)
 * ==============================================
 * Handles mobile-specific interactions and optimizations
 * NOTE: Sticky ATC is now handled by corporate-grind-mobile.js
 */

(function() {
  'use strict';
  
  // Prevent duplicate initialization
  if (window.__cgMobileUXInitialized) return;
  window.__cgMobileUXInitialized = true;
  
  const MobileUX = {
    config: {
      debounceDelay: 100,
      isMobile: window.innerWidth < 768
    },
    
    /**
     * Initialize all mobile UX enhancements
     */
    init() {
      console.log('🚀 Mobile UX Enhancements v2.0: Initializing...');
      
      if (this.config.isMobile) {
        // NOTE: Sticky ATC removed - handled by corporate-grind-mobile.js
        this.initMobileFilters();
        this.initTouchOptimizations();
        this.initScrollOptimizations();
      }
      
      // Always init responsive handlers
      this.initResponsiveHandlers();
      
      console.log('✅ Mobile UX Enhancements: Ready');
    },
    
    /**
     * Initialize mobile filter/sort controls
     */
    initMobileFilters() {
      // Only run on collection pages
      if (!document.body.classList.contains('template-collection')) {
        return;
      }
      
      console.log('🔍 Initializing Mobile Filters...');
      
      // Create mobile filter bar if it doesn't exist
      const filterBar = this.createMobileFilterBar();
      
      // Handle filter button click
      const filterButton = filterBar.querySelector('.mobile-filter-button');
      const sortButton = filterBar.querySelector('.mobile-sort-button');
      
      if (filterButton) {
        filterButton.addEventListener('click', () => {
          this.openFilterDrawer();
        });
      }
      
      if (sortButton) {
        sortButton.addEventListener('click', () => {
          this.openSortDrawer();
        });
      }
      
      console.log('✅ Mobile Filters initialized');
    },
    
    /**
     * Create mobile filter bar
     */
    createMobileFilterBar() {
      let filterBar = document.querySelector('.mobile-filter-bar');
      if (filterBar) return filterBar;
      
      filterBar = document.createElement('div');
      filterBar.className = 'mobile-filter-bar';
      filterBar.innerHTML = `
        <button class="mobile-filter-button" type="button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M2 4h16M6 10h8M9 16h2" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Filter</span>
        </button>
        <button class="mobile-sort-button" type="button">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M4 6h12M4 10h8M4 14h4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>Sort</span>
        </button>
      `;
      
      const collectionGrid = document.querySelector('.collection-grid, .product-grid');
      if (collectionGrid) {
        collectionGrid.parentNode.insertBefore(filterBar, collectionGrid);
      }
      
      return filterBar;
    },
    
    /**
     * Open filter drawer
     */
    openFilterDrawer() {
      console.log('📱 Opening filter drawer...');
    },
    
    /**
     * Open sort drawer
     */
    openSortDrawer() {
      console.log('📱 Opening sort drawer...');
    },
    
    /**
     * Touch optimizations for mobile
     */
    initTouchOptimizations() {
      console.log('👆 Initializing Touch Optimizations...');
      
      document.body.style.touchAction = 'manipulation';
      
      const buttons = document.querySelectorAll('button, .btn, .button');
      buttons.forEach(button => {
        button.style.touchAction = 'manipulation';
      });
      
      const carousels = document.querySelectorAll('.recently-viewed-grid, .recommendations-grid');
      carousels.forEach(carousel => {
        carousel.style.touchAction = 'pan-x';
      });
      
      console.log('✅ Touch Optimizations applied');
    },
    
    /**
     * Scroll optimizations for mobile
     */
    initScrollOptimizations() {
      console.log('📜 Initializing Scroll Optimizations...');
      
      const scrollElements = document.querySelectorAll('.recently-viewed-grid, .recommendations-grid');
      scrollElements.forEach(element => {
        element.addEventListener('scroll', () => {}, { passive: true });
      });
      
      // Intersection Observer for lazy animations
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.1,
          rootMargin: '50px'
        });
        
        const sections = document.querySelectorAll('section[data-animate]');
        sections.forEach(section => observer.observe(section));
      }
      
      console.log('✅ Scroll Optimizations applied');
    },
    
    /**
     * Responsive handlers for window resize
     */
    initResponsiveHandlers() {
      let resizeTimeout;
      
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.config.isMobile = window.innerWidth < 768;
        }, 250);
      }, { passive: true });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => MobileUX.init());
  } else {
    MobileUX.init();
  }
  
  window.CG = window.CG || {};
  window.CG.MobileUX = MobileUX;
  
})();
